import axios from "axios";

export const getLocale = () => {
  return axios.get("https://api.userinfo.io/userinfos").then(({ data }) => {
    const { code } = data.country;
    let currency = "usd";
    if (code) {
      currency = code.toLowerCase() === "hk" ? "hkd" : "usd";
    }
    return { ...data, currency };
  });
};

export const verifyCoupon = code =>
  axios
    .post("/.netlify/functions/verify-coupon", { code })
    .then(res => res.data);

export const requestUploadURLs = ({ length, overlay }) =>
  axios
    .post("/.netlify/functions/requestUploadURLs", {
      alpha: overlay*100,
      length
    })
    .then(res => res.data);



// WEBPACK FOOTER //
// ./src/api/index.js